export function fmt(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('ro-RO', { dateStyle: 'short', timeStyle: 'short' });
}
